<template>
  <el-dialog
    title="身份证信息"
    :visible.sync="dialogVisible"
    customClass="customWidth"
    @opened="dialogOpen"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="150px"
      size="mini"
    >
      <el-form-item
        prop="userName"
        label="三级代理名称"
      >
        {{userName}}
      </el-form-item>
      <el-form-item
        prop="identitynum"
        label="身份证号码"
      >
        {{identitynum}}
      </el-form-item>
      <el-form-item
              prop="idcards_front"
              label="身份证件照正面"
      >
        <div v-if="idcards_front !== ''" > <img :src= "getImgUrl()"  style="width: 400px;height: 300px; " /></div>
      </el-form-item>
      <el-form-item
              prop="idcards_back"
              label="身份证件照反面"
      >
        <div v-if="idcards_back !== ''" > <img :src= "getImgUrl2()"  style="width: 400px;height: 300px; " /></div>
      </el-form-item>

    </el-form>
  </el-dialog>

</template>
<style>
  .customWidth{
    width:60%;
  }
</style>
<script>
import * as agentService from '@/api/sys/agent'
import * as userService from '@/api/sys/user'
import util from '@/libs/util.js'
export default {
  name: 'sfzForm',
  props: {
    oneagent: Object,
    value: Boolean
  },
  data () {
    return {
      loading: false,
      dialogVisible: false,
      identitynum: '',
      idcards_front: '',
      idcards_back: '',
      userName: '',
      form: {
      }
    }
  },
  watch: {
    value (val) {
      this.dialogVisible = val
    },
    dialogVisible (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    getImgUrl () {
      return 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + this.idcards_front
    },

    getImgUrl2 () {
      return 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + this.idcards_back
    },
    dialogOpen () {
      this.$refs.form.resetFields()
      this.userName = this.oneagent.agentname
      if (this.oneagent.identitynum != null && this.oneagent.identitynum != '' && this.oneagent.identitynum != 'null') {
        this.identitynum = this.oneagent.identitynum
      }
      if (this.oneagent.idcards_front != null && this.oneagent.idcards_front != '' && this.oneagent.idcards_front != 'null') {
        this.idcards_front = this.oneagent.idcards_front
      }

      if (this.oneagent.idcards_back != null && this.oneagent.idcards_back != '' && this.oneagent.idcards_back != 'null') {
        this.idcards_back = this.oneagent.idcards_back
      }
    },
    close () {
      this.$refs['form'].resetFields()
      this.dialogVisible = false
    }
  }
}
</script>
